import React, { Component } from 'react';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Slider from "react-slick";
import { Row, Col } from 'react-bootstrap';
import SERVICES from '../../services/service'

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonials:[]
        }
    }

    async componentDidMount() {
        let testimonialDetails = await SERVICES._getTestimonials({});
        let testimonials = []
        if(testimonialDetails.status){
            testimonials = testimonialDetails.testimonials
        }
        this.setState({ testimonials : testimonials })
     }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            // autoplay: true,
            autoplaySpeed: 2000,
        };
        return (
            <div>
                <Slider {...settings}>
                {this.state.testimonials.map((result, index) => (
                    <div className="text-center slick-item" key={index}>
                        <img src={`https://api.gadgetzippy.com/testimonialIcons/${result.image_path}`} alt="SUNDAR PICCHAI" className="m-auto" />
                        <div className="slider-box">
                            <Row>
                                <Col className="pr-0" xs={2}>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/double-code-up.png`} alt="SUNDAR PICCHAI" className="float-right mt-1 w-320" />
                                </Col>
                                <Col xs={8} className="pr-0">
                                <div className="work-sec-item pt-4 mobile-slick-content">
                                <span>{result.description}</span>
                                     </div>
                                    </Col>
                                <Col xs>
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/double-code-down.png`} alt="SUNDAR PICCHAI" className="double-qqt" />
                                </Col>
                            </Row>
                            <div className="slick-content-name slick-content-name-m pt-3">{result.name}</div>
                        </div>
                    </div>
                ))}
                </Slider>
            </div>
        )
    }
}
